<template>
  <el-card class="!border-none" :body-style="{ height: '100%' }">
    <div class="w-full h-full">
      <el-page-header v-if="operateType" :content="title" @back="cancel"> </el-page-header>
      <div class="flex items-center" v-else>
        <span class="border-l-3 border-$systemMainColor flex-1 pl-10px text-18px">{{ title }}</span>
      </div>
      <el-form
        class="my-20px h-[calc(100%-94px)] overflow-auto"
        :model="formData"
        :rules="formRules"
        ref="formRef"
        label-width="150px"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="素材名称" prop="name">
              <el-input
                size="small"
                placeholder="请输入"
                v-model="formData.name"
                clearable
                :disabled="operateType"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="tabType === '2'">
            <el-form-item label="素材图片" prop="image">
              <el-upload
                ref="uploadRef"
                :class="operateType ? 'hidden' : ''"
                :disabled="operateType"
                action="xxx"
                :http-request="fileUpload"
                :file-list="fileImgList"
                :before-upload="beforeUpload"
                :on-success="uploadSuccess"
                :on-remove="onRemove"
                :on-preview="onPreview"
                :on-exceed="onExceed"
                drag
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过20mb</div>
              </el-upload>
              <div v-if="operateType">
                <!-- <div class="pl-10px truncate" v-for="(it, index) in successImgList" :key="index"> -->
                <!-- {{ it.fileName }} -->
                <!-- <span
                    @click="onPreview({ name: it.fileName })"
                    class="hover:text-hex-$buttonPrimarySelect hover:bg-$alarmInfoGreyBg hover:rounded-2px p-5px cursor-pointer inline-block w-full leading-20px"
                    >{{ it.fileName }}</span
                  >
                </div> -->
                <el-image
                  v-for="(it, index) in successImgList"
                  :key="index"
                  :src="`${fileUrl}${it.id}`"
                  class="w-60px h-60px mr-10px mb-10px"
                  :preview-src-list="[`${fileUrl}${it.id}`]"
                ></el-image>
              </div>
              <el-image
                ref="uploadImgRef"
                id="uploadImgId"
                :src="clickImg"
                class="w-0 h-0"
                :preview-src-list="[clickImg]"
              ></el-image>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="tabType === '3'">
            <el-form-item label="素材视频" prop="video">
              <el-upload
                :class="operateType ? 'hidden' : ''"
                :disabled="operateType"
                action="xxx"
                :http-request="fileUpload"
                :file-list="fileList"
                :before-upload="beforeUpload"
                :on-success="uploadSuccess"
                :on-remove="onRemove"
                :on-preview="onPreview"
                :on-exceed="onExceed"
                drag
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传一个mp4、wav文件，且不超过200mb</div>
              </el-upload>
              <div v-if="operateType">
                <div class="pl-10px truncate" v-for="(it, index) in successFileList" :key="index">
                  <span
                    @click="onPreview({ name: it.fileName })"
                    class="hover:text-hex-$buttonPrimarySelect hover:bg-$alarmInfoGreyBg hover:rounded-2px p-5px cursor-pointer inline-block w-full leading-20px"
                    >{{ it.fileName }}</span
                  >
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="mt-20px" v-if="tabType === '1'">
          <el-col :span="24">
            <richtextEditor
              v-if="!operateType"
              @change="handleRichtextEditor"
              :content="formData.content"
              class="h-480px"
            >
            </richtextEditor>
            <div v-else class="ql-container ql-snow">
              <div class="ql-editor" v-html="formData.content"></div>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="text-center" v-if="!operateType">
        <el-button type="primary" size="small" @click="save" :loading="saveLoading">保存</el-button>
        <el-button size="small" @click="cancel">取消</el-button>
        <!-- <el-button size="small" @click="test">测试</el-button> -->
      </div>
    </div>
  </el-card>
</template>

<script>
import { FileApi } from '@wiz-api/file-management'
import { MaterialApi } from '@wiz-api/workbench'
import dayjs from 'dayjs'

const fileApi = new FileApi()
const materialApi = new MaterialApi()
const richtextEditor = () => {
  return import('@/components/RichtextEditor')
}
export default {
  name: 'componentPublishingMaterialManagement',
  components: { richtextEditor },
  props: {
    operateType: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    tabType: {
      type: String,
      default: '1',
    },
    userInfo: {
      type: Object,
      default: () => {},
    },
    detailData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formData: {
        name: '',
        content: '',
        image: '',
        video: '',
      },
      formRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'change' }],
      },
      saveLoading: false,
      fileImgList: [],
      fileList: [],
      successImgList: [],
      successFileList: [],
      clickImg: '',
      getElTimer: null,
    }
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
  },
  methods: {
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const pubUpdate = {
            uploaderId: this.detailData.uploaderId,
            deptId: this.detailData.deptId,
            uploadTime: dayjs(this.detailData.uploadTime).format('YYYY-MM-DD HH:mm:ss'),
            status: this.detailData.status,
            name: this.formData.name,
          }
          const pubAdd = {
            uploaderId: this.userInfo.id,
            deptId: this.userInfo.organizationUnits[0].orgId,
            uploadTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            status: 0,
            name: this.formData.name,
          }
          let resAdd = null
          let resUpdate = null
          switch (this.tabType) {
            case '1':
              if (!this.detailData.id) {
                const params1 = {
                  body: {
                    content: this.formData.content,
                    ...pubAdd,
                  },
                }
                resAdd = await materialApi.addTextMaterial(params1)
              } else {
                const params1 = {
                  body: {
                    id: this.detailData.id,
                    content: this.formData.content,
                    ...pubUpdate,
                  },
                }
                resUpdate = await materialApi.updateTextMaterial(params1)
              }
              break
            case '2':
              if (!this.detailData.id) {
                const params3 = {
                  body: {
                    image: this.successImgList.length ? JSON.stringify(this.successImgList) : '',
                    ...pubAdd,
                  },
                }
                resAdd = await materialApi.addImageMaterial(params3)
              } else {
                const params3 = {
                  body: {
                    id: this.detailData.id,
                    image: this.successImgList.length ? JSON.stringify(this.successImgList) : '',
                    ...pubUpdate,
                  },
                }
                resUpdate = await materialApi.updateImageMaterial(params3)
              }
              break
            case '3':
              if (!this.detailData.id) {
                const params3 = {
                  body: {
                    video: this.successFileList.length ? JSON.stringify(this.successFileList) : '',
                    ...pubAdd,
                  },
                }
                resAdd = await materialApi.addVideoMaterial(params3)
              } else {
                const params3 = {
                  body: {
                    id: this.detailData.id,
                    video: this.successFileList.length ? JSON.stringify(this.successFileList) : '',
                    ...pubUpdate,
                  },
                }
                resUpdate = await materialApi.updateVideoMaterial(params3)
              }
              break
            default:
              break
          }
          if (resAdd && resAdd.length && !resAdd[0]) {
            this.$message.success('新增成功')
            this.$emit('success')
            this.cancel()
          }
          if (resUpdate && resUpdate.length && !resUpdate[0]) {
            this.$message.success('编辑成功')
            this.$emit('success')
            this.cancel()
          }
        }
      })
    },
    cancel() {
      this.$emit('close')
      this.successFileList = []
      this.successImgList = []
      if (this.getElTimer) clearInterval(this.getElTimer)
    },
    // 处理富文本编辑器传递回来的内容
    handleRichtextEditor(content) {
      this.formData.content = content
    },
    async fileUpload(file) {
      const [err, res] = await fileApi.upload({
        files: [file.file],
        authLevel: 2,
      })
      if (!err) {
        this.successImgList.push(res[0])
        this.successFileList.push(res[0])
      }
    },
    // 文件上传
    beforeUpload(file) {
      if (this.tabType === '2') {
        const isLimit = file.size / 1024 <= 20000
        if (!isLimit) {
          this.$message.warning('文件大小不能大于20M!')
          return false
        }
        const isImage = ['image/jpg', 'image/jpeg', 'image/png']
        const pass = isImage.includes(file.type)
        if (!pass) {
          this.$message.warning('请上传jpg/png格式的图片!')
          return false
        }
        const nameIndex = this.successImgList.findIndex((it) => {
          return it.fileName === file.name
        })
        if (nameIndex !== -1) {
          this.$message.warning('文件名称重复!')
          return false
        }
        return true
      }
      if (this.tabType === '3') {
        const isLimit = file.size / 1024 <= 200000
        if (!isLimit) {
          this.$message.warning('文件大小不能大于200M!')
          return false
        }
        const isImage = ['video/mp4', 'video/wav']
        const pass = isImage.includes(file.type)
        if (!pass) {
          this.$message.warning('请上传mp4/wav格式的视频!')
          return false
        }
        const nameIndex = this.successFileList.findIndex((it) => {
          return it.fileName === file.name
        })
        if (nameIndex !== -1) {
          this.$message.warning('文件名称重复!')
          return false
        }
        return true
      }
      return false
    },
    uploadSuccess(response, file, fileList) {},
    onPreview(file) {
      if (this.tabType === '2') {
        const currData = this.successImgList.find((it) => {
          return it.fileName === file.name
        })
        if (currData) {
          this.clickImg = `${this.fileUrl}${currData.id}`
          this.$nextTick(() => {
            if (this.getElTimer) clearInterval(this.getElTimer)
            this.getElTimer = setInterval(() => {
              const el = document.getElementById('uploadImgId')
              if (el) {
                el.click()
                clearInterval(this.getElTimer)
              }
            }, 50)
          })
        }
      } else if (this.tabType === '3') {
        const currData = this.successFileList.find((it) => {
          return it.fileName === file.name
        })
        if (currData) {
          const link = document.createElement('a')
          link.href = `${this.fileUrl}${currData.id}`
          link.click()
        }
      }
    },
    onExceed() {
      if (tabType === '3') {
        this.$message.warning('只能上传一个文件')
      }
    },
    onRemove(file) {
      this.successImgList = this.successImgList.filter((it) => {
        return it.fileName !== file.name
      })
      this.successFileList = this.successFileList.filter((it) => {
        return it.fileName !== file.name
      })
    },
  },
  created() {},
  mounted() {},
  watch: {
    detailData: {
      handler(val) {
        if (val) {
          this.formData.name = val.name
          switch (this.tabType) {
            case '1':
              this.formData.content = val.content
              break
            case '2':
              this.successImgList = val.image ? JSON.parse(val.image) : []
              this.fileImgList = this.successImgList.map((it) => {
                it.name = it.fileName
                return it
              })
              break
            case '3':
              this.successFileList = val.video ? JSON.parse(val.video) : []
              this.fileList = this.successFileList.map((it) => {
                it.name = it.fileName
                return it
              })
              break
            default:
              break
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.getElTimer) clearInterval(this.getElTimer)
  },
  deactivated() {
    if (this.getElTimer) clearInterval(this.getElTimer)
  },
}
</script>

<style lang="scss" scoped></style>
